import { connect } from 'react-redux';

import ActionInputEditor from 'app/developer-v3/pages/actions/ActionInputEditor/ActionInputEditor';
import {
  allServicesByType,
  availableTriggers,
  isCurrentAppDefinitionSaving,
} from 'app/developer-v3/selectors';
import { SERVICE_TYPE } from 'app/developer-v3/constants';

const mapStateToProps = state => ({
  isSaving: isCurrentAppDefinitionSaving(state),
  searches: Object.values(allServicesByType(SERVICE_TYPE.searches, state)),
  availableTriggers: Object.values(availableTriggers(state)),
});

export default connect(mapStateToProps)(ActionInputEditor);
